/* Generic */
export const DATE_FORMAT = "yyyy-MM-dd";
export const LOCALIZED_DATE_TIME_FORMAT = "Pp";
export const LOCALIZED_DATE_TIME_TIMEZONE_FORMAT = "Pp (zzzz)";

/* Rates */
export const RATES_INPUT_DATE_FORMAT = "y-LL-dd";
export const RATES_DISPLAY_DATE_FORMAT = "d LLL";

/* Tracking */
export const TRACKING_DATE_FORMAT = "yyyy-MM-dd";

/* Reservation */
export const RESERVATION_LOCALIZED_DATE_TIME_FORMAT = "E, PP - HH:mm";
